import * as React from 'react'
import { useMemo } from 'react'
import { useFetchActivityTypes } from '@user/features/Activity/hooks'
import { useActivitiesContext } from '@user/features/Activity/context'
import type { IProviderProps, IOption } from '@user/components/Filters'

export function ActivityTypeProvider(props: IProviderProps) {
  const { render } = props

  const status = useFetchActivityTypes()

  const [{ activityTypes }] = useActivitiesContext()

  const activityTypeOptions = useMemo(
    () =>
      activityTypes
        .filter((x) => Boolean(x.name))
        .map<IOption>((x) => ({
          value: x.id,
          label: x.name ?? '',
        })),
    [activityTypes],
  )

  return <>{render(activityTypeOptions, status === 'loading')}</>
}
